module.exports = __webpack_public_path__ + "static/media/google_play.912a15d5.png";